import { useState } from 'react';
import api from '../../shared/services/api/api';
import { useTranslation } from 'react-i18next';
import GenerateOrDownload from './GenerateOrDownload';

type ReportStudioProps = {
  patientId: string;
};

const ReportSummary = ({ patientId }: ReportStudioProps) => {
  const { t } = useTranslation();
  const [reportPdf, setReportPdf] = useState<string>('');
  const handleDownloadReport = async () => {
    const response = await api.generateSummaryReport({ code: patientId });
    setReportPdf(response);
  };
  return (
    <div>
      <div className="max-w-xl">
        <GenerateOrDownload
          handler={handleDownloadReport}
          link={reportPdf}
          handlerLabel={t('generate summary report')}
          linkLabel={t('download summary report')}
        />
      </div>
    </div>
  );
};

export default ReportSummary;
